<template>
  <b-container>
    <h1 v-translate>Manage Invoicing Data</h1>
    <hr>
    <div class="row">
      <div class="col-md-3">
        <profile-navigation />
      </div>
      <div class="col-md-9 personal-info">
        <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged">
          <p v-translate>Invoicing Data was updated!</p>
        </b-alert>
        <form class="" role="form">
          <div class="row">
            <h3 class="col-12" v-translate>Invoicing Data</h3>
            <div class="form-group col-md-12" v-for="(formField, index) in formFields" :key="formField[0] + index"
              :class="'invoicing-' + index">
              <label class="control-label">{{ formField }}</label>
              <input class="form-control col-md-6" type="text" v-model="invoicingData[index]" required>
            </div>
          </div>
          <div class="row text-left">
            <div class="form-group col-12 form-actions">
              <label class="col-md-3 control-label"></label>
              <div class="col-md-8">
                <b-button variant="primary" size="lg" @click.prevent="submit()" v-translate>Save Changes</b-button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </b-container>
</template>
<script>
const invoicingDataMap = {
  'AR': {
    country: 'País',
    company: 'Nombre de la empresa',
    cuit: 'CUIT/CUIL',
    address: 'Calle, número...',
    address_extra: 'Piso, puerta...',
    city: 'Ciudad',
    zip: 'Código postal',
    state: 'Provincia'
  }
}
import ProfileNavigation from '@/components/ProfileNavigation'
import { mapGetters } from 'vuex'
import { FETCH_PROFILE, UPDATE_USER } from '@/store/actions.type'
export default {
  name: 'ProfileInvoicingDataPage',
  title() {
    return this.$gettext('Invoicing Data « Edit Profile')
  },
  components: {
    ProfileNavigation
  },
  data() {
    return {
      breadcrumb: [{
        text: 'Home',
        to: { name: 'index' }
      }, {
        text: 'Profile',
        to: { name: 'profile' }
      }, {
        text: 'Invoicing Data',
        active: true
      }],
      formFields: invoicingDataMap.AR,
      invoicingData: {},
      formSaved: false,
      dismissSecs: 10,
      dismissCountDown: 0
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'isLoading'
    ])
  },
  created() {
    this.fetchProfile()
  },
  methods: {
    fetchProfile() {
      this.$store.dispatch(FETCH_PROFILE)
        .then(response => {
          if (this.user.billing_data !== null) {
            this.invoicingData = JSON.parse(this.user.billing_data)
          } else {
            for (let i in this.formFields) {
              this.invoicingData[i] = null
            }
          }
          if (this.user.profile_address_id === null) {
            this.user.profile_address = {
              place: {
                formatted_address: null
              }
            }
          }
        }, error => {
          let obj = {
            title: this.$gettext('ERROR'),
            message: error.body.message,
            type: 'error'
          }
          this.$parent.$refs.simplert.openSimplert(obj)
        })
    },
    submit() {
      delete this.user.phone
      this.$store.dispatch(UPDATE_USER, { billing_data: JSON.stringify(this.invoicingData) }).then(response => {
        this.showAlert()
        this.fetchProfile()
      })
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}

</script>
